import DiceRatings from "src/components/diceratings/DiceRatings";
import theme from "src/components/themes/DefaultTheme";
import styled, { css } from 'src/lib/styles/css';
import IPremiumLandingPage from "src/lib/types/IPremiumLandingPage";

//#region [Props]
type RatingsProps = {
	landingpage: IPremiumLandingPage;
};
//#endregion

//#region [Component]
export default function Ratings({ landingpage }: RatingsProps) {
	//if (!landingpage.showDice || (landingpage.movie.reviews?.length ?? 0) === 0) {
	if ((landingpage.movie.reviews?.length ?? 0) === 0 || (landingpage.dicePosition ?? "none") === "none") {
		return null;
	}
	return <SRatings $dicePos={landingpage.dicePosition ?? "none"}>
		<SDiceScroller>
			<SDiceRatings reviews={landingpage.movie.reviews} />
		</SDiceScroller>
	</SRatings>;
}
//#endregion

//#region [Styles]
type SRatingsProps = {
	$dicePos: "none" | "topOfPage" | "belowTitle";
}

const SRatings = styled.div<SRatingsProps>`
	--DICECOLOR-OVERRIDE: var(--ADFREE-DICECOLOR);
	--DICETEXTCOLOR-OVERRIDE: var(--ADFREE-DICETEXTCOLOR);
	max-width: 100vw;
	display: flex;
	justify-content: center;

	${props => props.$dicePos === "topOfPage" ? css`
		position: absolute;
		top: 5px;
		left: 50%;
		transform: translate(-50%);

		@media (min-width: 550px) {
			top: 20px;
		}
	`: ""}

`;

const SDiceScroller = styled.div`
	overflow: auto;
`;

const SDiceRatings = styled(DiceRatings)`
	display: inline-block;
	white-space: nowrap;
	margin: 0 auto;
	min-width: 0;
	padding: 10px;

	> div {
		display: inline-block;
		overflow: hidden;
		min-width: 19vw;
		max-width: 19vw;
		margin: 0 5px;

		@media (min-width: 550px) {
			min-width: 140px;
			max-width: 140px;
		}

		a {
			font-size: 12px;
		}
	}
`;
//#endregion